import React, { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "./firebase";
import { useNavigate } from "react-router-dom";

export default function DistributorDashboard({ uid }) {
  const navigate = useNavigate();
  const [stats, setStats] = useState([]);
  const [recentOrders, setRecentOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [distributorName, setDistributorName] = useState("");

  useEffect(() => {
    const userRef = ref(db, `users/${uid}`);
    onValue(userRef, (userSnapshot) => {
      const userData = userSnapshot.val();
      setDistributorName(userData?.tradeName || "Mon Entreprise");
    });
    
    const distributorRef = ref(db, `distributors/${uid}`);

    

    const unsub = onValue(distributorRef, snapshot => {
      const data = snapshot.val();
      if (!data) return;

      // ✅ جلب اسم الموزع الحقيقي
     
      // الإحصائيات
      const products = Object.values(data.products || {});
      const totalProducts = products.length;
      const lowStock = products.filter(p => (p.quantity || 0) < 10).length;

      const totalClients = Object.keys(data.clientsAdd || {}).length;

      const orders = Object.values(data.orders || {});
      const totalOrders = orders.length;
      const pendingOrders = orders.filter(o => o?.status === "pending").length;

      // إيرادات الشهر
      // ✅ حساب الربح الشهري الحقيقي
const now = new Date();
const monthStart = new Date(now.getFullYear(), now.getMonth(), 1).getTime();

let monthlyProfit = 0;

const monthOrders = orders.filter(
  o => o?.createdAt >= monthStart && o?.status === "Terminé"
);

monthOrders.forEach(order => {
  if (!order.products) return;

  Object.values(order.products).forEach(p => {
    const qty = parseInt(p.actualQuantity || p.quantity || 0);
    if (!qty) return;

    const salePrice = parseFloat(p.price || 0);

    // نفس منطق SoldProductsPage
    let purchasePrice = 0;
    if (p.purchasePrice !== undefined && p.purchasePrice !== null) {
      purchasePrice = parseFloat(p.purchasePrice);
    } else {
      purchasePrice = 0;
    }

    monthlyProfit += (salePrice - purchasePrice) * qty;
  });
});

      const statsList = [
        {
          title: "Produits",
          value: totalProducts,
          color: "#4361ee",
          icon: "📦",
          path: "/products",
          badge: lowStock > 0 ? `${lowStock} faible` : null
        },
        {
          title: "Clients",
          value: totalClients,
          color: "#f72585",
          icon: "👥",
          path: "/clients"
        },
        {
          title: "Commandes",
          value: totalOrders,
          color: "#4cc9f0",
          icon: "🛒",
          path: "/orders",
          badge: `${pendingOrders} en attente`
        },
        {
          title: "Revénu du mois",
          value: formatMoney(monthlyProfit),
          color: "#f8961e",
          icon: "💰",
          path: "/sold-products"
        },
        {
          title: "Marques",
          value: Object.keys(data.brands || {}).length,
          color: "#90be6d",
          icon: "🏷️",
          path: "/products/brands"
        },
        {
          title: "Catégories",
          value: Object.keys(data.categories || {}).length,
          color: "#577590",
          icon: "📑",
          path: "/products/categories"
        },
        {
          title: "Vendeurs",
          value: Object.keys(data.vendeurs || {}).length,
          color: "#7209b7",
          icon: "👤",
          path: "/vendeurs"
        },
        {
          title: "Statistiques",
          value: "Détails",
          color: "#b5838d",
          icon: "📊",
          path: "/sold-products"
        }
      ];

      setStats(statsList);

      // آخر 5 طلبيات
      const recent = Object.entries(data.orders || {})
        .map(([id, order]) => ({ id, ...order }))
        .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
        .slice(0, 5);
      setRecentOrders(recent);

      setLoading(false);
    });

    return () => unsub();
  }, [uid]);

  const formatMoney = (amount) => {
    return Number(amount || 0).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " DA";
  };

  const getStatusStyle = (status) => {
    const styles = {
      "Terminé": { bg: "#dcfce7", color: "#166534" },
      "pending": { bg: "#fef9c3", color: "#854d0e" },
      "Annulé": { bg: "#fee2e2", color: "#991b1b" }
    };
    return styles[status] || { bg: "#e2e8f0", color: "#334155" };
  };

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.loadingSpinner}></div>
        <p style={styles.loadingText}>Chargement...</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header مع ترحيب باسم الموزع الحقيقي */}
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>
            Bonjour, {distributorName} 👋
          </h1>
          <p style={styles.subtitle}>
            {distributorName === "Mon Entreprise" 
              ? "Bienvenue sur votre tableau de bord" 
              : `Gérez votre entreprise ${distributorName} efficacement`}
          </p>
        </div>
        <div style={styles.actions}>
          <button 
            onClick={() => navigate("/products/add")}
            style={styles.primaryButton}
          >
            ➕ Nouveau Produit
          </button>
          <button 
            onClick={() => navigate("/orders")}
            style={styles.secondaryButton}
          >
            📋 Commandes
          </button>
        </div>
      </div>

      {/* بطاقات الإحصائيات */}
      <div style={styles.statsGrid}>
        {stats.map((stat, index) => (
          <div
            key={index}
            style={styles.statCard}
            onClick={() => navigate(stat.path)}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 12px 20px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
            }}
          >
            <div style={styles.statIcon}>{stat.icon}</div>
            <div style={styles.statContent}>
              <div style={styles.statTitle}>{stat.title}</div>
              <div style={styles.statValue}>{stat.value}</div>
              {stat.badge && (
                <div style={styles.statBadge}>{stat.badge}</div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* قسمين متجاورين: الإجراءات السريعة + آخر الطلبيات */}
      <div style={styles.twoColumn}>
        {/* الإجراءات السريعة */}
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>⚡ Actions rapides</h3>
          <div style={styles.quickActions}>
            {[
              { icon: "➕", label: "Ajouter produit", path: "/products/add" },
              { icon: "📦", label: "Stock faible", path: "/products/low-stock" },
              { icon: "👥", label: "Nouveau client", path: "/add-client" },
              { icon: "📊", label: "Statistiques", path: "/sold-products" }
            ].map((action, i) => (
              <button
                key={i}
                style={styles.quickAction}
                onClick={() => navigate(action.path)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#e2e8f0';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#f8fafc';
                }}
              >
                <span style={styles.quickActionIcon}>{action.icon}</span>
                {action.label}
              </button>
            ))}
          </div>
        </div>

        {/* آخر الطلبيات */}
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>🕒 Dernières commandes</h3>
          {recentOrders.length > 0 ? (
            <div style={styles.ordersList}>
              {recentOrders.map((order) => {
                const statusStyle = getStatusStyle(order.status);
                return (
                  <div
                    key={order.id}
                    style={styles.orderItem}
                    onClick={() => navigate(`/order/${uid}/${order.id}`)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#f1f5f9';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#f8fafc';
                    }}
                  >
                    <div style={styles.orderHeader}>
                      <span style={styles.orderNumber}>
                        #{order.orderNumber || order.id.slice(-6)}
                      </span>
                      <span style={{
                        ...styles.orderStatus,
                        backgroundColor: statusStyle.bg,
                        color: statusStyle.color
                      }}>
                        {order.status || "N/A"}
                      </span>
                    </div>
                    <div style={styles.orderInfo}>
                      <span>{order.nameClientAdd || "Client"}</span>
                      <span style={styles.orderAmount}>
                        {formatMoney(order.totalPrice || 0)}
                      </span>
                    </div>
                    <div style={styles.orderDate}>
                      {order.createdAt ? new Date(order.createdAt).toLocaleDateString() : ""}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p style={styles.emptyText}>Aucune commande récente</p>
          )}
        </div>
      </div>

      {/* رسالة ترحيب إضافية للموزع */}
      {distributorName !== "Mon Entreprise" && (
        <div style={styles.welcomeMessage}>
          <p>
            ✨ Bienvenue {distributorName}! Vous avez {stats[0]?.value || 0} produits 
            et {stats[2]?.value || 0} commandes au total.
          </p>
        </div>
      )}
    </div>
  );
}

// ========== STYLES ==========
const styles = {
  container: {
    padding: '24px',
    backgroundColor: '#f8fafc',
    minHeight: '100vh',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '32px',
    flexWrap: 'wrap',
    gap: '16px'
  },
  title: {
    fontSize: '28px',
    fontWeight: '600',
    color: '#0f172a',
    margin: '0 0 4px 0'
  },
  subtitle: {
    fontSize: '16px',
    color: '#64748b',
    margin: 0
  },
  actions: {
    display: 'flex',
    gap: '12px'
  },
  primaryButton: {
    padding: '10px 20px',
    backgroundColor: '#4361ee',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  },
  secondaryButton: {
    padding: '10px 20px',
    backgroundColor: 'white',
    color: '#4361ee',
    border: '1px solid #4361ee',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '20px',
    marginBottom: '32px'
  },
  statCard: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
  },
  statIcon: {
    fontSize: '32px',
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f1f5f9',
    borderRadius: '12px'
  },
  statContent: {
    flex: 1
  },
  statTitle: {
    fontSize: '14px',
    color: '#64748b',
    marginBottom: '4px'
  },
  statValue: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#0f172a'
  },
  statBadge: {
    fontSize: '12px',
    color: '#ef4444',
    marginTop: '4px'
  },
  twoColumn: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
    marginBottom: '24px'
  },
  section: {
    backgroundColor: 'white',
    padding: '24px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#0f172a',
    margin: '0 0 20px 0'
  },
  quickActions: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '12px'
  },
  quickAction: {
    padding: '12px',
    backgroundColor: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    color: '#334155',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all 0.2s'
  },
  quickActionIcon: {
    fontSize: '18px'
  },
  ordersList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  orderItem: {
    padding: '16px',
    backgroundColor: '#f8fafc',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  orderHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px'
  },
  orderNumber: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#4361ee'
  },
  orderStatus: {
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: '500'
  },
  orderInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
    fontSize: '13px',
    color: '#64748b'
  },
  orderAmount: {
    fontWeight: '600',
    color: '#0f172a'
  },
  orderDate: {
    fontSize: '11px',
    color: '#94a3b8'
  },
  emptyText: {
    color: '#94a3b8',
    fontSize: '14px',
    textAlign: 'center',
    padding: '20px'
  },
  welcomeMessage: {
    marginTop: '24px',
    padding: '16px',
    backgroundColor: '#e0f2fe',
    borderRadius: '8px',
    color: '#0369a1',
    fontSize: '14px',
    textAlign: 'center'
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8fafc'
  },
  loadingSpinner: {
    width: '40px',
    height: '40px',
    border: '3px solid #e2e8f0',
    borderTopColor: '#4361ee',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },
  loadingText: {
    marginTop: '16px',
    color: '#64748b',
    fontSize: '16px'
  }
};

// إضافة animation
const style = document.createElement('style');
style.textContent = `
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
document.head.appendChild(style);